import React from 'react';
import { footerCSS } from './Footer.css';
import { peicarLogo2vector } from '../../Assets/Images';
import { Link } from 'react-router-dom';

function Footer(props) {
    return (
        <div css={footerCSS()} id="footerSectionID">
            <div className="First Block">
                <img src={peicarLogo2vector} alt='logo' />
                <div className='Text'>
                    <span className='One'>fácil. </span>
                    <span className='Two'>rápido. </span>
                    <span className='Three'>digital.</span>

                    <div className='RightsReserved'>
                        <div className='Terms'>
                            <Link to='/aviso-de-privacidad'>Aviso de privacidad</Link>
                            <p>|</p>
                            <Link to=''>Términos y condiciones</Link>
                        </div>
                        <span className='RightsLegend'>
                            Todos los derechos reservados © 2023
                        </span>
                    </div>
                </div>
            </div>

            <div className="Second Block">
                <div className="Line">

                </div>
            </div>

            <div className="Third Block">
                <span className='Email'>
                    contacto@peicar.com.mx
                </span>
                <span className='Telephone'>
                    T.  81 4894 7395
                </span>

                <span className='Cities'>
                    CDMX / EDO MEX / GUADALAJARA
                </span>
                <span className='CitiesDirection'>
                    TINTORETO 92 INT. 402 CIUDAD DE LOS DEPORTE
                    BENITO JUAREZ, CIUDAD DE MEXICO CIUDAD DE MEXICO 03710
                </span>

                <div className='RightsReserved'>
                    <div className='Terms'>
                        <Link to='/aviso-de-privacidad'>Aviso de privacidad</Link>
                        <p>|</p>
                        <Link to='/'>Términos y condiciones</Link>
                    </div>
                    <span className='RightsLegend'>
                        Todos los derechos reservados © 2023
                    </span>
                </div>
            </div>
        </div>
    );
}

export { Footer };